@if (showSidebar) {
  <app-sidebar></app-sidebar>
}

<main
  class="main-content"
  [class.with-sidebar]="showSidebar"
>
  <header class="main-header"   *ngIf="admin.user?.id">

    <a routerLink="/" class="header-brand">
      <div class="header-logo">
        M
      </div>

      <span>Menuload</span>
    </a>

    <div class="header-actions">

      <!-- <button class="header-icon-btn">
        <i class="fa-regular fa-bell"></i>
      </button> -->

      <app-profile></app-profile>

    </div>

  </header>

  <div class="page-content">
    <router-outlet></router-outlet>
  </div>

</main>
